/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';

import { AbstractRestService, identity, RestSettings } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';

import { getReportLink, ReportFilterDto } from './report-rest.dto';

@Injectable()
export class ReportRestService extends AbstractRestService {
  constructor(private settings: RestSettings) {
    super(settings);
  }

  generate(name: string, filter: ReportFilterDto): Observable<string> {
    return this.httpPost(`${this.bp}/reports/${name}`, filter, identity(), identity()).pipe(map$(getReportLink));
  }
}
